import { Product } from "../models/Product";

/**
 * @returns Precio calculado o null si no tiene descuento
 */
export function calculateProductPrice(product:Product) : number {
	if (product.product_discount && product.product_discount[0]) {
		return product.amount / 100 * (100-product.product_discount[0].amount);
	} else {
		return product.amount;
	}
}

/**
 * @returns Cantidad reducida por el descuento sobre el precio inicial
 */
export function calculateDiscountedAmount(product:Product) : number|null {
	if (product.product_discount && product.product_discount[0]) {
		return product.amount / (100 / product.product_discount[0].amount);
	} else {
		return null;
	}
}